import { noConsequentHyphens } from "@lib/validators/regex";
import { checkValidEmail } from "@lib/validators/user/logInSchema";
import { bool, object, string } from "yup";
import type { Header } from "../types";
import { VALIDATION_RULES } from "@lib/constants/formValidations";

type Config = {
    headers: Header;
    hasPolicyAgreement: boolean;
    hasExtendedNewsletterForm: boolean;
};

export const getValidationSchema = ({
    hasPolicyAgreement,
    headers,
    hasExtendedNewsletterForm,
}: Config) => {
    return object().shape({
        email: string()
            .required(headers.requiredField)
            .matches(noConsequentHyphens, headers.emailError)
            .email(headers.emailError)
            .max(VALIDATION_RULES.email.maxCharacters, headers.maxCharacters)
            .concat(checkValidEmail(headers.emailError)),
        ...(hasPolicyAgreement && {
            policy: bool().oneOf([true], headers.policy),
        }),
        ...(hasExtendedNewsletterForm && {
            name: string().required(headers.requiredField).max(25, headers.maxNameCharacters),
        }),
    });
};
